// Độ dài bài viết
// export const POST_LENGTHS = [
//   {
//     value: "70 - 150 từ",
//     label: "Ngắn gọn",
//   },
//   {
//     value: "250 - 400 từ",
//     label: "Vừa phải",
//   },
//   {
//     value: "500 - 750 từ",
//     label: "Chi tiết",
//   },
// ];

export const POST_LENGTHS = [
  {
    value: "Ngắn gọn",
    label: "Ngắn gọn",
  },
  {
    value: "Vừa phải",
    label: "Vừa phải",
  },
  {
    value: "Chi tiết",
    label: "Chi tiết",
  },
];

// Phong cách bài viết
export const POST_STYLES = [
  {
    value: "Chuyên nghiệp",
    label: "Chuyên nghiệp",
  },
  {
    value: "Hài hước",
    label: "Hài hước",
  },
  {
    value: "Sáng tạo",
    label: "Sáng tạo",
  },
  {
    value: "Kể chuyện",
    label: "Kể chuyện",
  },
  {
    value: "Quảng cáo",
    label: "Quảng cáo",
  },
  {
    value: "Truyền cảm hứng",
    label: "Truyền cảm hứng",
  },
];

// Default values
export const DEFAULT_POST_LENGTH = POST_LENGTHS[0].value;
export const DEFAULT_POST_STYLES = [POST_STYLES[0].value];
